import React, { useLayoutEffect } from 'react'
import url from 'front-end-core/core/url'
import cx from 'classnames'
import { CURRENT_AWARENESS } from 'constants/controllers'
import Grid from '@material-ui/core/Grid'
import { nowDateMinusOneMonth, nowDatePlusOneDay } from 'pages/currentawareness/Util'
import { CaThemeProvider } from 'components/redesign/CaThemeProvider'
import { AnnouncementsSkeleton, StoriesSkeleton } from 'pages/dashboard/Skeleton'
import Hidden from '@material-ui/core/Hidden'
import NewsTickerContainer from 'redux/containers/pages/dashboard/NewsTickerContainer'
import StoriesWrapperContainer from 'redux/containers/pages/dashboard/StoriesWrapperContainer'
import { useSelector } from 'react-redux'
import selectCmsCtx from 'redux/selectors/selectCmsCtx'
import selectPlaceholders from 'redux/selectors/selectPlaceholders'
import HomePageContentPanels from 'pages/dashboard/HomePageContentPanels'
import AnnouncementsHeader from 'pages/dashboard/AnnouncementsHeader'
import selectAolName from 'redux/selectors/selectAolName'

const ViewLatestUpdatesLink = () => {
  const aol = useSelector(selectAolName)
  const caUrl = url(CURRENT_AWARENESS, { aol })

  return (
    <div className='layout-width-constraint ml2-m flex min-h3 pb4 pb0-t pr6 flex-column-reverse-t items-center items-stretch-t'>
      <div className='flex grow-0 shrink-0 items-center mt6-t'>
        <h4 className='black b f3 mv0 ml4 ml6-m mr6 grow-0 shrink-0'>Latest News</h4>
        <a href={caUrl} className='dib f7 mt4 pointer no-underline hover-underline'>View all News</a>
      </div>
      <div className='basis0 grow-1 shrink-1 h3 min-h2 max-h8-t ml6 mr4 -mb4 ml0-t pv2 pv0-t'>
        <NewsTickerContainer />
      </div>
    </div>
  )
}

const Stories = () => {
  const { isHomePageStoriesLoaded } = useSelector(selectPlaceholders)
  const fromDate = nowDateMinusOneMonth()
  const toDate = nowDatePlusOneDay()

  return (
    <div className='bt-thick bt--light-sea-green-2'>
      {!isHomePageStoriesLoaded && <StoriesSkeleton />}
      <div className={cx({ dn: !isHomePageStoriesLoaded })}>
        <StoriesWrapperContainer {...{ fromDate, toDate }} />
      </div>
    </div>
  )
}

const GridLayout = ({ isLogged, setDashboardIsLoaded, cmsCtx }) => {
  useLayoutEffect(() => {
    setDashboardIsLoaded(!!cmsCtx)
  }, [setDashboardIsLoaded, cmsCtx])

  return (
    <div className='bg-ghost-grey'>
      <div className='bg-white relative pt4'>
        <ViewLatestUpdatesLink />
      </div>
      <div className={cx('layout-width-constraint bg-ghost-grey', { 'pt0 pb8': isLogged, pv0: !isLogged })}>
        <CaThemeProvider>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={9}>
              <Stories />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={3}>
              <ContentPanelsWrapper />
            </Grid>
          </Grid>
        </CaThemeProvider>
      </div>
    </div>
  )
}

const ContentPanelsWrapper = () => {
  const { isHomepageFcUpdatesLoaded } = useSelector(selectPlaceholders)
  const cmsCtx = useSelector(selectCmsCtx)

  return (
    <div className='bg-ghost-grey'>
      <Hidden mdDown>
        <AnnouncementsHeader />
      </Hidden>
      {!isHomepageFcUpdatesLoaded && (
        <>
          <Hidden mdDown>
            <AnnouncementsSkeleton maxHeight={1712} />
          </Hidden>
          <Hidden lgUp>
            <AnnouncementsSkeleton maxHeight={595} />
          </Hidden>
        </>
      )}
      <div className={cx({ dn: !isHomepageFcUpdatesLoaded })}>
        {cmsCtx && <HomePageContentPanels {...{ cmsCtx }} />}
      </div>
    </div>
  )
}

export default GridLayout
